import { CITIES } from '@/lib/city'
import type { CityConfig } from '@/lib/city'

interface LandingPageProps {
  lang: 'el' | 'en'
  t: {
    neverMissBus: string
    realTimeTracking: string
    selectCity: string
    realTimeETA: string
    busLocations: string
    favoriteStops: string
  }
}

export function LandingPage({ lang, t }: LandingPageProps) {
  const cities = Object.values(CITIES)
  
  // Build the URL for a city based on current hostname
  const getCityUrl = (city: CityConfig) => {
    const hostname = window.location.hostname
    const port = window.location.port ? `:${window.location.port}` : ''
    const protocol = window.location.protocol
    
    // For localhost, use subdomain.localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      const subdomain = city.subdomains[0] // Use first subdomain (ath, skg)
      return `${protocol}//${subdomain}.localhost${port}/`
    }
    
    // For other domains, prepend subdomain
    const subdomain = city.subdomains[0]
    return `${protocol}//${subdomain}.${hostname}${port}/`
  }

  return (
    <div className="landing-page">
      <div className="landing-hero">
        <p className="landing-tagline">
          {t.neverMissBus}
        </p>
        <p className="landing-subtitle">
          {t.realTimeTracking}
        </p>
      </div>

      <div className="landing-cities">
        <h2 className="landing-cities-title">
          {t.selectCity}
        </h2>
        
        <div className="city-cards">
          {cities.map(city => (
            <a
              key={city.id}
              href={getCityUrl(city)}
              className="city-card"
            >
              <div className="city-card-icon">
                {city.id === 'athens' ? '🏛️' : '⛪'}
              </div>
              <div className="city-card-content">
                <h3 className="city-card-name">
                  {lang === 'el' ? city.nameGreek : city.name}
                </h3>
                <p className="city-card-authority">
                  {lang === 'el' ? city.authorityGreek : city.authority}
                </p>
              </div>
              <div className="city-card-arrow">→</div>
            </a>
          ))}
        </div>
      </div>

      <div className="landing-features">
        <div className="feature">
          <span className="feature-icon">⏱️</span>
          <span className="feature-text">
            {t.realTimeETA}
          </span>
        </div>
        <div className="feature">
          <span className="feature-icon">📍</span>
          <span className="feature-text">
            {t.busLocations}
          </span>
        </div>
        <div className="feature">
          <span className="feature-icon">⭐</span>
          <span className="feature-text">
            {t.favoriteStops}
          </span>
        </div>
      </div>
    </div>
  )
}
